import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Mail } from 'lucide-react';
import MailMergeDialog from './MailMergeDialog';

interface MailMergeButtonProps {
  leads: any[];
}

const MailMergeButton: React.FC<MailMergeButtonProps> = ({ leads }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setOpen(true)}
        className="whitespace-nowrap gap-1.5 h-8 sm:h-9 px-2 sm:px-3 text-xs sm:text-sm"
      >
        <Mail className="h-4 w-4" />
        <span className="hidden sm:inline">Mail Merge</span>
      </Button>
      <MailMergeDialog open={open} onOpenChange={setOpen} leads={leads} />
    </>
  );
};

export default MailMergeButton;
